<template>
  <div class="chatbot_wrap">
    <a class="btn_chatbot" href="javascript:void(0)" @click="openChatbotPopup()">챗봇</a>
    <div class="hover-layer">
      <p>챗봇에게 물어보세요</p>
    </div>
    <div v-if="isShowChatbot === true">
      <div class="dimd" @click="closeChatbotPopup()" />
      <div
        :style="[isMobile ? {maxHeight : '100vh'} : {maxHeight: 'calc(100vh - 94px)'}]"
        class="iframe_wrap"
        @click="closeChatbotPopup()">
        <a class="btn_close_chat" href="javascript:void(0)">챗봇닫기</a>
        <iframe
          v-if="isShowChatbot"
          :width="isMobile ? '100%' : '412px'"
          :height="calcIframeHeight"
          :src="chatbotUrl"
          frameborder="0"
          scrolling="no"
        />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Date : 2024/03/07
 * Author : min026.jeong@multicampus.com
 * Object : (LCPLAN-13041:MMP챗봇 개발)
 */

export default {
  name: 'ChatbotWrapper',
  components: {
  },
  data () {
    return {
      isMobile: false,
      isShowChatbot: false,
      chatbotUrl: 'https://chatbot.multicampus.com/konanbot?domain=d2831239539&user=19a8948f-87b8-4d40-b700-3165dd9317a6_',
      innerHeight: 704
    }
  },
  computed: {
    calcIframeHeight () {
      return this.isShowChatbot ? !this.isMobile ? this.innerHeight <= 798 ? (this.innerHeight - 94) + 'px;' : '704px;' : this.innerHeight + 'px;'
        : ''
    }
  },
  watch: {
    isShowChatbot (val) {
      window.document.body.style.setProperty('overflow', val ? 'hidden' : this.bodyOriginalOverflow)
      if (window.fdp && window.fdp.platform === 'ios') {
        window.document.body.style.setProperty('position', val ? 'fixed' : this.bodyOriginalPosition)
      }
    }
  },
  created () {
    if (window.innerWidth <= 768) {
      this.isMobile = true
    }
    window.addEventListener('resize', this.resizeScreen)
    this.bodyOriginalOverflow = window.document.body.style.overflow
    this.bodyOriginalPosition = window.document.body.style.position
  },
  mounted () {
    this.resizeScreen()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeScreen)
  },
  methods: {
    resizeScreen () {
      if (window.innerWidth <= 768) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
      this.innerHeight = window.innerHeight
    },
    openChatbotPopup () {
      this.isShowChatbot = true
    },
    closeChatbotPopup () {
      this.isShowChatbot = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/chatbot/ChatbotWrapper.vue